import React from 'react';
import { Box, Heading, Image } from '@wix/design-system';

export type CategoryPageHeaderProps = {
  title: string;
  subtitle: string;
  imageUrl: string;
};

export function CategoryPageHeader({
  title,
  subtitle,
  imageUrl,
}: CategoryPageHeaderProps) {
  return (
    <Box align="space-between" gap="120px">
      <Box direction="vertical" gap="6px">
        <Heading as="h1" size="small">
          {title}
        </Heading>
        <Heading as="h2" size="extraLarge">
          {subtitle}
        </Heading>
      </Box>

      <Box minWidth="96px" verticalAlign="middle">
        <Image width="96px" height="96px" transparent={true} src={imageUrl} />
      </Box>
    </Box>
  );
}
